import { it, de, pt, fr, es} from "../i18n/";

const translations = {it: it, de: de, pt: pt, fr: fr, es: es};

export default function getLocalisation() {
    if (cpAppSet.currentLocale) {
        const currentCode = cpAppSet.currentLocale.substring(0, 2);
        return translations[currentCode] || null;
    }
    return null;
}

